import cx from "classnames";
import React, { type FC, type HTMLAttributes } from "react";

import DangerousHTML from "../DangerousHTML";
import { type PrintImageData, extractPrintImageData } from "./printImage";

import * as styles from "./IframeEmbedContent.module.scss";

interface Props extends HTMLAttributes<HTMLElement> {
	embedHtml: string;
	printImage?: PrintImageData | null;
}

export const IframeEmbedContent: FC<Props> = ({
	embedHtml,
	printImage,
	className,
	...rest
}) => {
	if (!embedHtml) return null;

	if (!printImage) {
		return <DangerousHTML html={embedHtml} className={className} {...rest} />;
	}

	return (
		<div className={cx(styles.component, className)} {...rest}>
			<div className={cx(styles.screenEmbed, "hideOnPrint")}>
				<DangerousHTML html={embedHtml} />
			</div>
			<div
				className={cx(
					styles.printImageWrapper,
					"showOnPrint",
					"printAvoidPageBreakInside",
				)}
			>
				<img
					className={styles.printImage}
					src={printImage.src}
					alt={printImage.alt || ""}
				/>
			</div>
		</div>
	);
};

export { extractPrintImageData };

export default IframeEmbedContent;
